let routes = [{
  path: '/',
  component: (resolve) => require(['./page/index/index'], resolve),
},{
  path: '/RegQuery',
  component: (resolve) => require(['./page/RegQuery/RegQuery'], resolve),
},{
  path: '/About',
  component: (resolve) => require(['./page/about/about'], resolve),
},{
  path: '/Education',
  component: (resolve) => require(['./page/education/education'], resolve),
},{
  path: '/ApplyReg',
  component: (resolve) => require(['./page/applyReg/applyReg'], resolve),
},{
  path: '/InfoState',
  component: (resolve) => require(['./page/InfoState/InfoState'], resolve),
},{
  path: '/Profession',
  component: (resolve) => require(['./page/profession/Profession'], resolve),
},{
  path: '/Login',
  component: (resolve) => require(['./page/login/login'], resolve),
},{
  path: '/Reg',
  component: (resolve) => require(['./page/login/reg'], resolve),
},{
  path: '/Retrieve',
  component: (resolve) => require(['./page/login/retrieve'], resolve),
},{
  path: '/UserInfo',
  component: (resolve) => require(['./page/user/index'], resolve),
},{
  path: '/Publicity',
  component: (resolve) => require(['./page/publicity/Publicity'], resolve),
},{
  path: '/InfoDetail',
  component: (resolve) => require(['./page/education/InfoDetail'], resolve),
},{
  path: '/projectReview',
  component: (resolve) => require(['./page/projectReview/index'], resolve),
},{
  path: '/updateRegistration',
  component: (resolve) => require(['./page/updateRegistration/index'], resolve),
},{
  path: '/updateRegistrationRecord',
  component: (resolve) => require(['./page/updateRegistrationRecord/index'], resolve),
},{
  path: '/NoticeList',
  component: (resolve) => require(['./page/NoticeList/index'], resolve),
}];

export default routes;